/**
 * author: Soumya Shreyas
 */
import React, { useState } from "react";
import { withTranslation } from "react-i18next";

import "react-datepicker/dist/react-datepicker.css";

import { Dropdown } from "react-bootstrap";
import { CgSortAz } from "react-icons/cg";
import SupplierTasksList from "../SupplierTasksList/SupplierTasksList";
import IncidentList from "../IncidentList/IncidentList";
import SupplierDashboardCompaniesRiskBox from "./SupplierDashboardCompaniesRiskBox";
import OpenFormSubmissions from "../../Common/Forms/FormSubmitted/OpenFormSubmissions";

const SupplierDashboardListBox = ({ t, type, annualyear }) => {
  const [filter, setFilter] = useState('all');

  const getBoxHeading = () => {
    if (type === 'TASK') {
      return filter === 'assignedToMe' 
      ? t("TasksAssignedToMe.label") : filter === 'createdByMe' 
      ? t("TasksCreatedByMe.label") : t("MyTasks.label");
    } else if (type === 'INCIDENT') {
      return filter === 'assignedToMe' 
      ? t("IncidentsAssignedToMe.label") : filter === 'createdByMe' 
      ? t("IncidentsRaisedByMe.label") : t("MyIncidents.label");
    } else if (type === 'HIGH_RISK_COMPANIES') {
      return t("Top5HighRiskCompanies.label");
    } else if (type === 'FORM') {
      return t("MyOpenForms.label");
    }
  };

  const getFilterOptionsToRender = () => {
    if (type === 'TASK') {
      return <>
        <Dropdown.Item onClick={() => setFilter('all')}>
          {t("AllTasks.label")}
        </Dropdown.Item>
        <Dropdown.Item onClick={() => setFilter('assignedToMe')}>
          {t("AssignedToMe.label")}
        </Dropdown.Item>  
        <Dropdown.Item onClick={() => setFilter('createdByMe')}>
          {t("CreatedByMe.label")}
        </Dropdown.Item>  
      </>
    } else if (type === 'INCIDENT') {
      return <>
        <Dropdown.Item onClick={() => setFilter('all')}>
          {t("AllIncidents.label")}
        </Dropdown.Item>
        <Dropdown.Item onClick={() => setFilter('assignedToMe')}>
          {t("AssignedToMe.label")}
        </Dropdown.Item>  
        <Dropdown.Item onClick={() => setFilter('createdByMe')}>
          {t("RaisedByMe.label")}
        </Dropdown.Item>  
      </>
    }
  };

  return (
    <div className="card card-box01">
      <div className="card-box01_head">
        <h6>{getBoxHeading()}</h6>
        { type !== 'HIGH_RISK_COMPANIES' && type !== 'FORM' &&
          <div>
            <ul>
              <li className="filter">
                <Dropdown>
                <Dropdown.Toggle variant="blank_outline">
                <CgSortAz /> {t("Filter.label")}
                </Dropdown.Toggle>
                <Dropdown.Menu>{getFilterOptionsToRender()}</Dropdown.Menu>
              </Dropdown>
              </li>
            </ul>
          </div>
        }
      </div>
      <div className="card-box01_body">
        {type === 'TASK' && <SupplierTasksList detailedView={false} externalFilter={filter}/>}
        {type === 'INCIDENT' && <IncidentList detailedView={false} externalFilter={filter}/>}
        {type === 'HIGH_RISK_COMPANIES' && <SupplierDashboardCompaniesRiskBox selYear={annualyear} />}
        {type === 'FORM' && <OpenFormSubmissions />}
      </div>
    </div>
  );
};
export default withTranslation()(SupplierDashboardListBox);
